/**
 * Livre des recettes : modes de règlement et agrégats partagés entre l'API
 * (export) et le front (tableaux, graphique).
 */
export const PAYMENT_METHODS = ['transfer', 'card', 'cash', 'check', 'other'];
export const PAYMENT_METHOD_LABELS = {
    transfer: 'Virement',
    card: 'Carte bancaire',
    cash: 'Espèces',
    check: 'Chèque',
    other: 'Autre',
};
/** Total encaissé par période (`YYYY-MM` ou `YYYY-T1`…), en centimes pour éviter la dérive. */
export function totalsByPeriod(receipts, period) {
    const cents = new Map();
    for (const receipt of receipts) {
        const [year, month] = receipt.receivedOn.split('-');
        const key = period === 'month' ? `${year}-${month}` : `${year}-T${Math.ceil(Number(month) / 3)}`;
        cents.set(key, (cents.get(key) ?? 0) + Math.round(receipt.amount * 100));
    }
    return new Map([...cents].map(([key, value]) => [key, value / 100]));
}
//# sourceMappingURL=receipts.js.map